// extracted by mini-css-extract-plugin
export default {"container":"container--U70ucJ+wc+","selection":"selection--m+Q1xuG3wW"};